<template lang="pug">
	el-dialog(title="调整赛制" width="80%" :visible.sync="visible" :append-to-body="true" :modal-append-to-body="false" @close="closeForm()" class="fromlist")
		div(style="display: flex; align-items: center;")
			div(style="margin-left: 72px; color: #606266;")
				span(style="color: red;") * &nbsp;
				span 签位：
			div(style="display: flex; align-items: center;")
				el-input(
					v-model="ruleForm.applySize"
					style="width: 200px;"
					placeholder="请填写签位"
					clearable
				)
				div(style="margin-left: 20px; color: #909399; font-weight: bold;") (已报名 {{ruleForm.joinCount}} 队！)
		div(v-if="competitionRules.length !== 0" style="padding: 20px;")
			el-tabs(v-model="competitionRulesTab")
				el-tab-pane(v-for="(item, index) in cities" :keys="index" :label="item.value" :name="item.label" :disabled="item.disabed")
					div
						div(style="display: flex;")
							div(v-if="!legacyFormat" style="margin-right: 20px; display: flex; align-items: center;")
								div
									span(style="margin-right: 37px; color: red;")
									span 级别别名：
								div
									el-input(
										v-model="competitionRules[index].groupNickname"
										style="width: 200px;"
										placeholder="请填写级别别名"
										maxlength="50"
										clearable
									)
							div(style="display: flex; align-items: center;")
								div
									span(style="color: red;") *&nbsp;
									span 级别队伍数：
								div
									el-input(
										v-model="competitionRules[index].teamNum"
										style="width: 200px;"
										placeholder="请填写级别队伍数"
										maxlength="3"
										clearable
										@change="changeappsize(index)"
									)
						div(style="margin-top: 10px; display: flex;")
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span(style="color: red;") *&nbsp;
									span 第一阶段赛制：
								div
									el-select(
										v-model="competitionRules[index].FirstCompetition"
										style="width: 200px;"
										placeholder="请选择第一阶段赛制"
										clearable
										@change="changeFirstCompetitionRule(index)"
									)
										el-option(
											v-for="(item, index) in firstCompetitionRuleList"
											:label="item.label"
											:value="item.value"
											:disabled="item.disabled"
										)
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span(style="margin-right: 41px;") *&nbsp;
									span 组数：
								div
									el-input(
										v-model="competitionRules[index].groupNum"
										:disabled="competitionRules[index].FirstCompetition !== 1"
										style="width: 200px;"
										placeholder="请填写组数"
										maxlength="3"
										clearable
										@change="changeGroupNum(index)"
									)
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span *&nbsp;
									span 第一阶段赛制附加规则：
								div
									el-select(
										v-model="competitionRules[index].allowPlayOff"
										:disabled="competitionRules[index].FirstCompetition !== 5"
										style="width: 240px;"
										placeholder="请选择第一阶段赛制附加规则"
										clearable
									)
										el-option(
											v-for="(item, index) in firstCompetitionRulePlusList"
											:label="item.label"
											:value="item.value"
										)
							div(style="display: flex; align-items: center;")
								div
									span *&nbsp;
									span 小组晋级人数：
								div
									el-input(
										v-model="competitionRules[index].groupRiseNum"
										:disabled="competitionRules[index].FirstCompetition !== 1"
										style="width: 200px;"
										placeholder="请填写小组晋级人数"
										maxlength="3"
										clearable
										@change="changeGroupRiseNum(index)"
									)
						div(style="margin-top: 10px; display: flex;")
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span(style="color: red;") *&nbsp;
									span 第二阶段赛制：
								div
									el-select(
										v-model="competitionRules[index].SecondCompetition"
										:disabled="competitionRules[index].FirstCompetition !== 1 || Number(competitionRules[index].groupNum) === 1 || !competitionRules[index].groupNum"
										style="width: 200px;"
										placeholder="请选择第二阶段赛制"
										clearable
										@change="changeSecondCompetitionRule(index)"
									)
										el-option(
											v-for="(item, index) in secondCompetitionRuleList"
											:label="item.label"
											:value="item.value"
										)
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span(style="margin-right: 27px;") *&nbsp;
									span 交叉数：
								div
									el-select(
										v-model="competitionRules[index].crossNum"
										:disabled="competitionRules[index].SecondCompetition !== 4"
										style="width: 200px;"
										placeholder="请选择交叉数"
										clearable
									)
										el-option(
											v-for="(item, index) in crossNumList"
											:label="item.label"
											:value="item.value"
										)
							div(style="margin-right: 20px; display: flex; align-items: center;")
								div
									span *&nbsp;
									span 第二阶段赛制附加规则：
								div
									el-select(
										v-model="competitionRules[index].allowPlayOff1"
										:disabled="competitionRules[index].SecondCompetition !== 5"
										style="width: 240px;"
										placeholder="请选择第二阶段赛制附加规则"
									)
										el-option(
											v-for="(item, index) in firstCompetitionRulePlusList"
											:label="item.label"
											:value="item.value"
											:disabled="item.value === 1 && (Number(competitionRules[index].groupNum) * Number(competitionRules[index].groupRiseNum)) === 2"
										)
		span.dialog-footer(slot="footer")
			el-button(type="primary" :disabled="sureBtn" @click="sure") 确 定
			el-button(@click="visible = false;") 取 消
</template>
<script>
export default {
	name: 'AdjustGameSys',
	data () {
		return {
			visible: false,
			sureBtn: false,
      legacyFormat: false,
			ruleForm: {
				ctId: '',
				ctType: '',
				applySize: '',
				joinCount: '',
				groupFormatList: []
			},
      cities: [
        { label: '1', value: '甲A', disabed: true },
        { label: '2', value: '甲B', disabed: true },
        { label: '3', value: '乙A', disabed: true },
        { label: '4', value: '乙B', disabed: true },
        { label: '5', value: '丙A', disabed: true },
        { label: '6', value: '丙B', disabed: true },
        { label: '7', value: '丁A', disabed: true },
        { label: '8', value: '丁B', disabed: true },
        { label: '9', value: '资格甲', disabed: true },
        { label: '10', value: '资格乙', disabed: true },
        { label: '11', value: '资格丙', disabed: true },
        { label: '12', value: '资格丁', disabed: true }
      ],
      competitionRulesTab: '',
      competitionRules: [],
      firstCompetitionRuleList: [
        { value: 0, label: '淘汰附加赛' },
        { value: 1, label: '小组循环赛' },
        { value: 5, label: '淘汰赛' },
				{ value: 7, label: '俱乐部队队碰赛', disabled: true }
      ],
      firstCompetitionRulePlusList: [
        { label: '第三四名争夺季军', value: 1 },
        { label: '无附加赛', value: 0 }
      ],
      secondCompetitionRuleList: [
        { value: 2, label: '同名次小组循环赛' },
        { value: 3, label: '同名次淘汰附加赛' },
        { value: 4, label: '交叉淘汰附加赛' },
        { value: 5, label: '淘汰赛' }
      ],
      crossNumList: [
        { value: 2, label: '2' }
      ]
		}
	},
	methods: {
    init (id) {
      this.visible = true
      this.sureBtn = true
      this.legacyFormat = false
      this.ruleForm = this.$options.data().ruleForm
      this.cities = this.$options.data().cities
      this.competitionRules = []
      this.competitionRulesTab = ''
      this.firstCompetitionRuleList[3].disabled = true
      return this.$http({
        url: this.$http.adornUrl('/ctCompetition/getId/' + id),
        method: 'get'
      }).then((data) => {
        if (!data || data.code !== 0 || !data.bean) return
        const bean = data.bean
        const groupFormats = bean.competitionMatchFormatGroupList || []
        const formats = bean.competitionMatchFormatList || []
        this.legacyFormat = groupFormats.length === 0
        this.ruleForm.ctId = bean.id
        this.ruleForm.ctType = bean.ctType
        this.ruleForm.applySize = Number(bean.applySize)
        this.ruleForm.joinCount = Number(bean.joinCount)
        if (this.legacyFormat) {
          // 旧赛制是赛事共用配置，不按组别复制或转换为新赛制。
          this.cities = [{ label: 'legacy', value: '通用赛制', disabed: false }]
        } else {
          const clubLimit = String(bean.clubLimit || '').split(',').filter(Boolean)
          this.cities.forEach(item => {
            item.disabed = !clubLimit.includes(item.label) &&
              !groupFormats.some(format => Number(format.groupCode) === Number(item.label))
          })
        }
        const valueOrEmpty = value => value == null ? '' : value
        this.competitionRules = this.cities.map(item => {
          const stages = this.legacyFormat ? formats : groupFormats.filter(format => Number(format.groupCode) === Number(item.label))
          const first = stages.find(format => Number(format.stage) === 1) || {}
          const second = stages.find(format => Number(format.stage) === 2) || {}
          return {
            ctId: bean.id,
            groupCode: item.label,
            groupName: item.value,
            groupNickname: first.groupNickname || '',
            teamNum: valueOrEmpty(this.legacyFormat ? bean.teamNum : first.levelNum),
            FirstCompetition: valueOrEmpty(first.matchFormat),
            groupNum: valueOrEmpty(first.groupNum),
            allowPlayOff: first.allowPlayOff == null ? 0 : first.allowPlayOff,
            playOffPlace: valueOrEmpty(first.playOffPlace),
            groupRiseNum: valueOrEmpty(first.groupRiseNum),
            SecondCompetition: valueOrEmpty(second.matchFormat),
            crossNum: valueOrEmpty(second.crossNum),
            allowPlayOff1: second.allowPlayOff == null ? 0 : second.allowPlayOff
          }
        })
        const active = this.cities.findIndex(item => !item.disabed)
        if (active >= 0) {
          this.competitionRulesTab = this.cities[active].label
          this.firstCompetitionRuleList[3].disabled = Number(this.competitionRules[active].teamNum) !== 2
        }
        this.sureBtn = false
      }).catch(() => {
        this.$message.error('赛制加载失败，请关闭后重试')
      })
    },
    changeappsize (flag = '') {
      if (flag || flag === 0) {
        // "级别队伍数" === 2 时, 就可以选择"俱乐部对对碰赛"了
        if (Number(this.competitionRules[flag].teamNum) === 2) {
          this.firstCompetitionRuleList[3].disabled = false
        } else {
          this.firstCompetitionRuleList[3].disabled = true
        }

        // 如果"级别队伍数" !== 2, 并且第一阶段赛制选择了"俱乐部对对碰赛", 则需要将"第一阶段赛制"清空, 因为"级别队伍数" === 2 时才能选择"俱乐部对对碰赛"
        if (Number(this.competitionRules[flag].teamNum) !== 2 && this.competitionRules[flag].FirstCompetition === 7) {
          this.competitionRules[flag].FirstCompetition = ''
        }

        // "签位数" 必须为 "级别队伍数量" 的倍数
        // if (Number(this.ruleForm.applySize) % Number(this.competitionRules[flag].teamNum) !== 0) {
        //   this.$confirm('当前系统支持签位数必须为级别队伍数量的倍数，请重新设置！', '提示', {
        //     showCancelButton: false,
        //     confirmButtonText: '确定',
        //     type: 'warning'
        //   })
        // }

        // ctType === 5 挑战赛时, 总分组 (签位 / 级别队伍数) 应 <= 4
        // if (this.ruleForm.ctType === 5 && (Number(this.competitionRules[flag].teamNum) || Number(this.competitionRules[flag].teamNum) === 0)) {
        //   if (this.ruleForm.applySize / Number(this.competitionRules[flag].teamNum) > 4) {
        //     this.$confirm('挑战赛事总分组（即总签位 / 级别队伍数）应不大于4，请重新设置！', '提示', {
        //       showCancelButton: false,
        //       confirmButtonText: '确定',
        //       type: 'warning'
        //     })
        //   }
        // }

        // ctType === 6 群英赛, 总分组 (签位 / 级别队伍数) 应 <= 8
        // if (this.ruleForm.ctType === 6 && (Number(this.competitionRules[flag].teamNum) || Number(this.competitionRules[flag].teamNum) === 0)) {
        //   if (this.ruleForm.applySize / Number(this.competitionRules[flag].teamNum) > 8) {
        //     this.$confirm('群英赛事总分组（即总签位 / 级别队伍数）应不大于8，请重新设置！', '提示', {
        //       showCancelButton: false,
        //       confirmButtonText: '确定',
        //       type: 'warning'
        //     })
        //   }
        // }
      }
    },
    // 修改"第一阶段赛制"时触发
    changeFirstCompetitionRule (flag) {
      this.competitionRules[flag].groupNum = ''
      this.competitionRules[flag].allowPlayOff = ''
      this.competitionRules[flag].groupRiseNum = ''
      this.competitionRules[flag].SecondCompetition = ''
      this.competitionRules[flag].crossNum = ''
      this.competitionRules[flag].allowPlayOff1 = ''

      // 俱乐部对对碰赛
      if (this.competitionRules[flag].FirstCompetition === 7) {
        this.competitionRules[flag].groupNum = 1 // 组数
      }

      // 淘汰赛
      if (this.competitionRules[flag].FirstCompetition === 5) {
        this.competitionRules[flag].allowPlayOff = 0
      }
    },
    changeGroupNum (flag = '') {
      if (flag || flag === 0) {
        // 组数 === 1 || 组数为空
        if (this.competitionRules[flag].groupNum == 1 || this.competitionRules[flag].groupNum == '') {
          this.competitionRules[flag].SecondCompetition = '' // 清空第二阶段赛制
          this.competitionRules[flag].crossNum = '' // 清空交叉数
          this.competitionRules[flag].allowPlayOff1 = '' // 清空第二阶段赛制附加规则
        }

        // 第二赛制为 同名次小组循环赛
        if (this.competitionRules[flag].SecondCompetition === 2) {
          // 组数 < 2 && 组数 > 6
          if (this.competitionRules[flag].groupNum < 2 || this.competitionRules[flag].groupNum > 6) {
            this.$confirm('因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置组数！', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            })
          }
        }

        if (
          this.competitionRules[flag].allowPlayOff1 === 1 &&
          (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
          this.competitionRules[flag].SecondCompetition === 5
        ) {
          this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }
    },
    // 修改"第一阶段小组晋级人数"时触发
    changeGroupRiseNum (flag) {
      // 签位 和 组数 都已填写
      if (this.competitionRules[flag].teamNum && this.competitionRules[flag].groupNum) {
        // 第一阶段小组晋级人数 > 每组人数
        if (Number(this.competitionRules[flag].groupRiseNum) > (Number(this.competitionRules[flag].teamNum) / Number(this.competitionRules[flag].groupNum))) {
          this.$confirm('第一阶段小组晋级人数不能超过小组人数，请重新设置！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }

      if (
        this.competitionRules[flag].allowPlayOff1 === 1 &&
        (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
        this.competitionRules[flag].SecondCompetition === 5
      ) {
        this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    },
    // 修改"第二阶段赛制"时触发
    changeSecondCompetitionRule (flag) {
      this.competitionRules[flag].crossNum = ''
      this.competitionRules[flag].allowPlayOff1 = ''

      // 第二赛制为"同名次小组循环赛"
      if (this.competitionRules[flag].SecondCompetition === 2) {
        // 组数 < 2 && 组数 > 6
        if (this.competitionRules[flag].groupNum < 2 || this.competitionRules[flag].groupNum > 6) {
          this.$confirm('因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置组数！', '提示', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'warning'
          })
        }
      }

      // 第二阶段赛制为"淘汰赛"
      if (this.competitionRules[flag].SecondCompetition === 5) {
        this.competitionRules[flag].allowPlayOff1 = 1 // 第二阶段赛制附加规则为"第三四名争夺季军"
      }

      if (
        this.competitionRules[flag].allowPlayOff1 === 1 &&
        (Number(this.competitionRules[flag].groupNum) * Number(this.competitionRules[flag].groupRiseNum) === 2) &&
        this.competitionRules[flag].SecondCompetition === 5
      ) {
        this.$confirm('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！', '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    },
		sure () {
			// 赛制相关数据校验
			if (
				!this.ruleForm.applySize ||
				!Number.isInteger(Number(this.ruleForm.applySize))
			) {
				return this.$confirm(`请确认签位数是否填写正确！`, '提示', {
					showCancelButton: false,
					confirmButtonText: '确定',
					type: 'warning'
				})
			}
			if (Number(this.ruleForm.applySize) < Number(this.ruleForm.joinCount)) {
				return this.$confirm(`签位数不能小于当前已报名队伍数！`, '提示', {
					showCancelButton: false,
					confirmButtonText: '确定',
					type: 'warning'
				})
			}

      let teamNumAll = 0
			const matchFormatArr = []
			for (let i = 0; i < this.competitionRules.length; i++) {
				if (!this.cities[i].disabed && this.competitionRules[i].teamNum) {
					// ==================================================级别队伍数==================================================
					if (
						!Number.isInteger(Number(this.competitionRules[i].teamNum)) ||
						Number(this.competitionRules[i].teamNum) <= 0
					) {
						return this.$confirm(`请确认${this.cities[i].value}的级别队伍数是否填写正确！`, '提示', {
							showCancelButton: false,
							confirmButtonText: '确定',
							type: 'warning'
						})
					}

          teamNumAll += Number(this.competitionRules[i].teamNum)

					// "签位数" 必须为 "级别队伍数量" 的倍数
					// if (Number(this.ruleForm.applySize) % Number(this.competitionRules[i].teamNum) !== 0) {
					// 	return this.$confirm(`当前系统支持签位数必须为级别队伍数量的倍数，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
					// 		showCancelButton: false,
					// 		confirmButtonText: '确定',
					// 		type: 'warning'
					// 	})
					// }

					// ctType === 5 挑战赛时, 总分组 (签位 / 级别队伍数) 应 <= 4
					// if (this.ruleForm.ctType === 5) {
					// 	if (this.ruleForm.applySize / Number(this.competitionRules[i].teamNum) > 4) {
					// 		return this.$confirm(`挑战赛事总分组（即总签位 / 级别队伍数）应不大于4，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
					// 			showCancelButton: false,
					// 			confirmButtonText: '确定',
					// 			type: 'warning'
					// 		})
					// 	}
					// }

					// ctType === 6 群英赛, 总分组 (签位 / 级别队伍数) 应 <= 8
					// if (this.ruleForm.ctType === 6) {
					// 	if (this.ruleForm.applySize / Number(this.competitionRules[i].teamNum) > 8) {
					// 		return this.$confirm(`群英赛事总分组（即总签位 / 级别队伍数）应不大于8，请重新设置${this.cities[i].value}的级别队伍数！`, '提示', {
					// 			showCancelButton: false,
					// 			confirmButtonText: '确定',
					// 			type: 'warning'
					// 		})
					// 	}
					// }
					// ==================================================级别队伍数==================================================

					if (!this.competitionRules[i].FirstCompetition && this.competitionRules[i].FirstCompetition !== 0) {
						return this.$confirm(`请选择${this.cities[i].value}的第一阶段赛制！`, '提示', {
							showCancelButton: false,
							confirmButtonText: '确定',
							type: 'warning'
						})
					}

					// 小组循环赛
					if (this.competitionRules[i].FirstCompetition === 1) {
						// 组数
						if (
							!this.competitionRules[i].groupNum ||
							!Number.isInteger(Number(this.competitionRules[i].groupNum)) ||
							Number(this.competitionRules[i].groupNum) <= 0
						) {
							return this.$confirm(`请确认${this.cities[i].value}的第一阶段组数是否填写正确！`, '提示', {
								showCancelButton: false,
								confirmButtonText: '确定',
								type: 'warning'
							})
						}

						// 第一阶段小组晋级人数
						if (
							!this.competitionRules[i].groupRiseNum ||
							!Number.isInteger(Number(this.competitionRules[i].groupRiseNum)) ||
							Number(this.competitionRules[i].groupRiseNum) <= 0
						) {
							return this.$confirm(`请确认${this.cities[i].value}的第一阶段小组晋级人数是否填写正确！`, '提示', {
								showCancelButton: false,
								confirmButtonText: '确定',
								type: 'warning'
							})
						}

						// 第一阶段小组晋级人数 > 每组人数
						if (Number(this.competitionRules[i].groupRiseNum) > (Number(this.competitionRules[i].teamNum) / Number(this.competitionRules[i].groupNum))) {
							return this.$confirm(`第一阶段小组晋级人数不能超过小组人数，请重新设置${this.cities[i].value}的第一阶段小组晋级人数！`, '提示', {
								showCancelButton: false,
								confirmButtonText: '确定',
								type: 'warning'
							})
						}

						// 第二阶段赛制
						if ((!this.legacyFormat || Number(this.competitionRules[i].groupNum) > 1) && !this.competitionRules[i].SecondCompetition && this.competitionRules[i].SecondCompetition !== 0) {
							return this.$confirm(`请选择${this.cities[i].value}的第二阶段赛制！`, '提示', {
								showCancelButton: false,
								confirmButtonText: '确定',
								type: 'warning'
							})
						}

						// 同名次小组循环赛
						if (this.competitionRules[i].SecondCompetition === 2) {
							if (this.competitionRules[i].groupNum < 2 || this.competitionRules[i].groupNum > 6) {
								this.$confirm(`因第二阶段同名次小组循环赛系统支持2-6签的小组对阵，故第一阶段小组循环赛分组数也需满足2-6组，请重新设置${this.cities[i].value}的第一阶段的组数！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}
						}

						// 交叉淘汰附加赛
						if (this.competitionRules[i].SecondCompetition === 4) {
							// 交叉数
							if (!this.competitionRules[i].crossNum) {
								return this.$confirm(`请选择${this.cities[i].value}的第二阶段的交叉数！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}
							const num = Number(this.competitionRules[i].groupRiseNum)
							if (num === 0 || num % 2 !== 0) { // 第一阶段小组晋级人数必须是大于0的偶数
								return this.$confirm(`第二阶段赛制为交叉淘汰附加赛时，第一阶段小组晋级人数必须为大于0的偶数，请重新设置${this.cities[i].value}的第一阶段小组晋级人数！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}
						}

						// 淘汰赛
						if (this.competitionRules[i].SecondCompetition === 5) {
							// 第二阶段赛制附加规则
							if (!this.competitionRules[i].allowPlayOff1 && this.competitionRules[i].allowPlayOff1 !== 0) {
								return this.$confirm(`请选择${this.cities[i].value}的第二阶段赛制附加规则！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}

							if (
								this.competitionRules[i].SecondCompetition === 5 &&
								(Number(this.competitionRules[i].groupNum) * Number(this.competitionRules[i].groupRiseNum) === 2) &&
								this.competitionRules[i].allowPlayOff1 === 1
							) {
								return this.$confirm(`${this.cities[i].value}的第一阶段小组晋级人数导致第二阶段参赛队伍为2支，第二阶段赛制附加规则请选择“无附加赛”！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}
						}

						// 同名次淘汰附加赛/交叉淘汰附加赛/淘汰赛
						if ([3, 4, 5].includes(this.competitionRules[i].SecondCompetition)) {
							const num = Number(this.competitionRules[i].groupNum)
							if (isNaN(num) || !(num > 0 && (num & (num - 1)) === 0)) { // 组数必须是2的幂次方
								return this.$confirm(`第二阶段赛制为${this.secondCompetitionRuleList.find(item => item.value === this.competitionRules[i].SecondCompetition).label}时，第一阶段组数必须为2的幂次方，如：2、4、8、16...，请重新设置${this.cities[i].value}的第一阶段组数！`, '提示', {
									showCancelButton: false,
									confirmButtonText: '确定',
									type: 'warning'
								})
							}
						}
					}
					// 淘汰赛
					if (this.competitionRules[i].FirstCompetition === 5) {
						// 第一阶段赛制附加规则
						if (!this.competitionRules[i].allowPlayOff && this.competitionRules[i].allowPlayOff !== 0) {
							return this.$confirm(`请选择${this.cities[i].value}的第一阶段赛制附加规则！`, '提示', {
								showCancelButton: false,
								confirmButtonText: '确定',
								type: 'warning'
							})
						}
						this.competitionRules[i].playOffPlace = this.competitionRules[i].allowPlayOff === 0 ? 0 : 4
					}
					matchFormatArr.push(this.competitionRules[i])
				}
			}

			if (this.legacyFormat ? (!teamNumAll || Number(this.ruleForm.applySize) % teamNumAll !== 0) : Number(this.ruleForm.applySize) !== teamNumAll) {
				return this.$confirm(this.legacyFormat ? '签位数必须是级别队伍数的整数倍，请重新设置！' : '级别队伍数的总和应等于签位数，请重新设置！', '提示', {
					showCancelButton: false,
					confirmButtonText: '确定',
					type: 'warning'
				})
			}

			const arr = []
			matchFormatArr.forEach(item => {
				// 除了小组循环赛，其它类型赛事都没有第二阶段
				if (item.FirstCompetition !== 1) {
					arr.push({
						// id: item.id,
						ctId: item.ctId,
						stage: 1,
						groupCode: Number(item.groupCode),
						groupName: item.groupName,
						groupNickname: item.groupNickname,
						levelNum: Number(item.teamNum),
						matchFormat: item.FirstCompetition,
						groupNum: Number(item.groupNum),
						allowPlayOff: item.allowPlayOff,
						groupRiseNum: Number(item.groupRiseNum),
						playOffPlace: item.playOffPlace
					})
				} else { // 小组循环赛
					arr.push({
						// id: item.id,
						ctId: item.ctId,
						stage: 1,
						groupCode: Number(item.groupCode),
						groupName: item.groupName,
						groupNickname: item.groupNickname,
						levelNum: Number(item.teamNum),
						matchFormat: item.FirstCompetition,
						groupNum: Number(item.groupNum),
						allowPlayOff: item.allowPlayOff,
						groupRiseNum: Number(item.groupRiseNum),
						playOffPlace: item.playOffPlace
					})
					arr.push({
						// id: item.id,
						ctId: item.ctId,
						stage: 2,
						groupCode: Number(item.groupCode),
						groupName: item.groupName,
						groupNickname: item.groupNickname,
						levelNum: Number(item.teamNum),
						matchFormat: item.SecondCompetition,
						crossNum: item.crossNum,
						allowPlayOff: item.allowPlayOff
					})
				}
			})
      let payload
      if (this.legacyFormat) {
        const item = matchFormatArr[0]
        const hasSecond = item.FirstCompetition === 1 && Number(item.groupNum) > 1 && item.SecondCompetition !== ''
        payload = {
          ctId: this.ruleForm.ctId,
          applySize: Number(this.ruleForm.applySize),
          teamNum: Number(item.teamNum),
          firstFormat: item.FirstCompetition,
          secondFormat: hasSecond ? item.SecondCompetition : null,
          groupNum: item.FirstCompetition === 1 ? Number(item.groupNum) : null,
          firstGroupRiseNum: item.FirstCompetition === 1 ? Number(item.groupRiseNum) : null,
          firstAllowPlayOff: item.allowPlayOff,
          crossNum: hasSecond && item.SecondCompetition === 4 ? Number(item.crossNum) : null,
          secondAllowPlayOff: hasSecond ? item.allowPlayOff1 : null
        }
      } else {
        payload = { ...this.ruleForm, groupFormatList: arr }
      }

			this.$confirm(`若已有成绩录入，系统将清空所有成绩及积分，重新生成新的对阵表，请谨慎操作，数据不可恢复！`, '确认调整赛制？', {
				confirmButtonText: '确定',
				type: 'warning'
			})
				.then(() => {
					this.sureBtn = true
					this.$http({
						url: this.$http.adornUrl(`/ctCompetition/changeFormat`),
						method: 'post',
						data: payload
					}).then((data) => {
						if (data && data.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.$emit('refreshSortFormatrList')
									this.visible = false
								}
							})
						} else {
							this.sureBtn = false
						}
					}).catch(() => {
						this.sureBtn = false
					})
				})
				.catch(() => {

				})
		},
		closeForm () {
			this.visible = false
		}
	}
}
</script>
